import { Link } from 'react-router';
import { Logo } from '@/components/Brand';
import { Button } from '@/components/ui/Button';

export function NotFoundPage() {
  return (
    <div className="flex min-h-dvh flex-col items-center justify-center gap-4 bg-sidebar px-6 text-center">
      <Logo size={56} className="opacity-60 grayscale" />
      <h1 className="text-3xl font-extrabold tracking-tight">This fire has gone out</h1>
      <p className="max-w-md text-fg-muted">The page you're looking for doesn't exist or was moved.</p>
      <Link to="/app/@me">
        <Button size="lg">Take me home</Button>
      </Link>
    </div>
  );
}
